/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import "./src/styles/constants/color.css"
import "./src/styles/fonts.css"
import "./src/styles/global.css"

// You can delete this file if you're not using it

// Consent
import React from "react"
import ConsentProvider from "./src/components/Consent/consentprovider"
import { getClientRegion, fetchConsent, writeConsent, getUserId, pushConsentUpdate, generateDefaultConsent, applyGoogleConsent, pushConsentWrite } from "./lib/consentHelper";
import { attachTCF } from './src/components/Consent/iabtcfgen'

import consentConfig from './config/consent-config'
const ISCMPREGISTERED = consentConfig.IABCMPID > 0;


// This loads before Tag manager
export const onClientEntry = async () => {

	if (typeof window !== "undefined") {
		if (!window.dataLayer) {
			window.dataLayer = []
		}

		if (!window.gtag) {
			window.gtag = function () {
				window.dataLayer.push(arguments)
			}
		}

	}
	/* Check first if user already has a stored consent data */
	const userId = getUserId()
	let consentdata = {}

	try {
		const result = await fetchConsent(userId, "cookie", ISCMPREGISTERED)

		if (result && result.consent) {
			consentdata = result.consent
		}
	} catch (e) {
		console.warn("Consent load failed:", e)
	}

	const userHasConsentData = Object.keys(consentdata).length > 0;

	if (typeof navigator !== 'undefined' && navigator.globalPrivacyConsent === true) {
		// If GPC is enabled (regardless if user already has consent data or not), consider as Reject All.
		consentdata = generateDefaultConsent(false)

		let storeConsent = true;

		let gpcExp = localStorage.getItem("gpcExp");
		if (gpcExp !== null) {
			if (Date.now() < gpcExp) storeConsent = false;
		}

		if (storeConsent) {
			const enriched = attachTCF(consentdata);
			const mode = userHasConsentData ? "PUT" : "POST";

			try {
				await writeConsent(userId, enriched, mode, "cookie", ISCMPREGISTERED);
				pushConsentWrite(userId, enriched, mode);
				localStorage.setItem("gpcExp", Date.now() + (30 * 60 * 1000)); // 30 minutes
			} catch (e) {
				console.warn("Consent write failed:", e);
			}
		}

		pushConsentUpdate(userId, consentdata);
		applyGoogleConsent(consentdata, true);
	} else if (!userHasConsentData) {
		// If user has no consent stored yet, generate default consent by region.
		let regionData = { region: "GB", type: "TCF" };

		// Initial value
		consentdata = generateDefaultConsent(undefined, regionData);
		pushConsentUpdate(userId, consentdata);
		applyGoogleConsent(consentdata, true);

		// Note: Made it .then() instead of async/await so that is is
		// non-blocking if request takes too long
		getClientRegion()
		.then((regionData) => {
			consentdata = generateDefaultConsent(undefined, regionData);
			pushConsentUpdate(userId, consentdata);
			applyGoogleConsent(consentdata, false);
		}).catch(e => {
			console.warn("Client region load failed: ", e);
		});
	}
}

export const wrapRootElement = ({ element }) => (
	<ConsentProvider>{element}</ConsentProvider>
)
